import { forwardRef } from "react";

import { RadioGroup, RadioGroupProps, RadioGroupSubComponents, RefComponent } from "capitalrx-components-2.0/lib/forms";
import { Field } from "capitalrx-components-2.0/lib/forms/RadioGroup/Field";
import { Option } from "capitalrx-components-2.0/lib/forms/RadioGroup/Option";
import { Placeholder } from "capitalrx-components-2.0/lib/forms/RadioGroup/Placeholder";
import { withSubComponents } from "capitalrx-components-2.0/lib/utilities";
import styled from "styled-components";

import "./Radio.scss";

interface ThemedRadioGroupSubComponents extends RadioGroupSubComponents {
  readonly Field: typeof _ThemedRadioGroupField;
}

const _ThemedRadioGroupField = styled(Field)`
  .dot:focus {
    box-shadow: 0px 0px 4px ${(props) => props.theme.primary_button_color} !important;
  }

  .selected {
    .dot-container {
      background-color: ${(props) => props.theme.primary_button_color} !important;
      border-color: ${(props) => props.theme.primary_button_color} !important;
    }
  }
`;

export const ThemedRadioGroup = withSubComponents<RefComponent<HTMLInputElement, RadioGroupProps>, ThemedRadioGroupSubComponents>(
  {
    Option: Option,
    Field: _ThemedRadioGroupField,
    Placeholder: Placeholder,
  },
  forwardRef(function FRThemedRadioGroup(props, ref) {
    return <RadioGroup {...props} ref={ref} />;
  }),
);
